import { gql } from '@apollo/client'
import {
  FRAGMENT_CONTACT_CHORE,
  FRAGMENT_PATIENT_PROFILE_CHORE,
} from './fragments'

export const GET_PATIENT_PROFILE = gql`
  query getPatientProfile($patientId: String!) {
    getPatientProfile(patientId: $patientId) {
      ...patientProfileChore
      gender
      bloodType
      takenMedicines
      medicineIntolerance
      emergencyContacts {
        ...contactChore
      }
      entitleToInfoContacts {
        ...contactChore
      }
      emailSettings
      weight
      height
    }
  }
  ${FRAGMENT_PATIENT_PROFILE_CHORE}
  ${FRAGMENT_CONTACT_CHORE}
`

export const UPDATE_PATIENT_PROFILE = gql`
  mutation updatePatientProfile(
    $updatePatientInput: EditablePatientData!
    $patientId: String!
  ) {
    updatePatientProfile(
      updatePatientInput: $updatePatientInput
      patientId: $patientId
    ) {
      id
    }
  }
`
